"use strict";

exports.__esModule = true;
exports.CalendarEventTypeField = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CalendarEventTypeField = exports.CalendarEventTypeField = function CalendarEventTypeField(_ref) {
  var prefix = _ref.prefix;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: prefix + ".type"
  }, function (_ref2) {
    var input = _ref2.input,
      meta = _ref2.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: meta.touched && meta.error ? "danger" : "secondary",
      helperText: meta.touched && meta.error ? meta.error : translate("CalendarEventTypeField.helperText", "The type of this event."),
      label: translate("CalendarEventTypeField.label", "Type"),
      labelFor: prefix + ".type",
      requiredLabel: "*"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "bp6-select"
    }, /*#__PURE__*/_react["default"].createElement("select", input, /*#__PURE__*/_react["default"].createElement("option", {
      value: "Shift"
    }, translate("CalendarEventTypeField.shift", "Shift")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "Classification"
    }, translate("CalendarEventTypeField.classification", "Classification")))));
  });
};